import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const PolitiqueConfidentialite = () => {
  return (
    <Layout>
      <SEOHead
        title="Politique de confidentialité - JIIA Studio"
        description="Politique de confidentialité et protection des données personnelles de JIIA Studio."
        canonical="/politique-de-confidentialite"
      />

      <section className="py-24 md:py-32">
        <div className="container max-w-3xl">
          <h1 className="font-heading text-4xl md:text-5xl font-light mb-4">Politique de confidentialité</h1>
          <p className="text-sm text-muted-foreground font-body mb-12">Dernière mise à jour : mars 2026</p>

          <div className="space-y-8 font-body text-muted-foreground leading-relaxed text-sm">
            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">1. Responsable du traitement</h2>
              <p>
                Le responsable du traitement des données personnelles collectées sur ce site est :<br />
                <strong className="text-foreground">JIIA STUDIO SASU</strong><br />
                3 rue des Forges, 69290 Grézieu-la-Varenne<br />
                SIRET : 937 972 057 00015<br />
                Représentée par Charline Jacob, Présidente.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">2. Données collectées</h2>
              <p>Dans le cadre de l'utilisation du site, JIIA Studio peut collecter les données suivantes :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li><strong className="text-foreground">Formulaire de contact</strong> : nom, adresse e-mail, numéro de téléphone (optionnel), type de projet, message.</li>
                <li><strong className="text-foreground">Formulaire de soumission photo</strong> : nom, adresse e-mail, numéro de téléphone (optionnel), photo de pièce, message (optionnel).</li>
                <li><strong className="text-foreground">Newsletter</strong> : adresse e-mail.</li>
                <li><strong className="text-foreground">Données de navigation</strong> : via Google Analytics (voir section Cookies ci-dessous).</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">3. Finalités du traitement</h2>
              <p>Les données personnelles sont collectées pour les finalités suivantes :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Répondre à vos demandes de contact et de devis.</li>
                <li>Vous envoyer un e-mail de confirmation de bonne réception.</li>
                <li>Vous envoyer la newsletter JIIA Studio (inspirations, réalisations, conseils) si vous y êtes inscrit(e).</li>
                <li>Analyser la fréquentation du site pour en améliorer le contenu et l'expérience.</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">4. Base légale du traitement</h2>
              <p>
                Le traitement de vos données repose sur votre <strong className="text-foreground">consentement</strong> (article 6.1.a du RGPD), 
                recueilli via les formulaires du site et le bandeau de consentement aux cookies.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">5. Destinataires des données</h2>
              <p>Vos données personnelles sont transmises uniquement aux destinataires suivants :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li><strong className="text-foreground">Charline Jacob</strong> (JIIA Studio) - traitement de votre demande.</li>
                <li><strong className="text-foreground">Resend</strong> (service d'envoi d'e-mails) - acheminement des notifications.</li>
                <li><strong className="text-foreground">Google Analytics</strong> - analyse de la fréquentation (sous réserve de votre consentement).</li>
              </ul>
              <p className="mt-2">Vos données ne sont jamais vendues ni cédées à des tiers à des fins commerciales.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">6. Durée de conservation</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong className="text-foreground">Données de contact</strong> : conservées pendant 3 ans à compter du dernier contact.</li>
                <li><strong className="text-foreground">Newsletter</strong> : votre adresse e-mail est conservée jusqu'à votre désabonnement. Vous pouvez vous désabonner à tout moment via le lien présent dans chaque newsletter.</li>
                <li><strong className="text-foreground">Données de navigation (cookies)</strong> : 13 mois maximum conformément aux recommandations de la CNIL.</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">7. Cookies</h2>
              <p>Ce site utilise les cookies suivants :</p>
              <div className="mt-3 overflow-x-auto">
                <table className="w-full text-sm border border-border">
                  <thead>
                    <tr className="bg-secondary">
                      <th className="text-left p-3 text-foreground font-medium">Cookie</th>
                      <th className="text-left p-3 text-foreground font-medium">Fournisseur</th>
                      <th className="text-left p-3 text-foreground font-medium">Finalité</th>
                      <th className="text-left p-3 text-foreground font-medium">Durée</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t border-border">
                      <td className="p-3">cookie_consent</td>
                      <td className="p-3">JIIA Studio</td>
                      <td className="p-3">Mémorise votre choix de consentement</td>
                      <td className="p-3">12 mois</td>
                    </tr>
                    <tr className="border-t border-border">
                      <td className="p-3">_ga, _ga_*</td>
                      <td className="p-3">Google Analytics</td>
                      <td className="p-3">Mesure d'audience anonymisée</td>
                      <td className="p-3">13 mois</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="mt-3">
                Vous pouvez à tout moment modifier vos préférences en matière de cookies en supprimant 
                le cookie « cookie_consent » de votre navigateur.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">8. Vos droits</h2>
              <p>Conformément au RGPD, vous disposez des droits suivants sur vos données personnelles :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li><strong className="text-foreground">Droit d'accès</strong> : obtenir la confirmation du traitement de vos données et en recevoir une copie.</li>
                <li><strong className="text-foreground">Droit de rectification</strong> : demander la correction de données inexactes ou incomplètes.</li>
                <li><strong className="text-foreground">Droit à l'effacement</strong> : demander la suppression de vos données.</li>
                <li><strong className="text-foreground">Droit à la limitation</strong> : demander la limitation du traitement.</li>
                <li><strong className="text-foreground">Droit d'opposition</strong> : vous opposer au traitement de vos données.</li>
                <li><strong className="text-foreground">Droit à la portabilité</strong> : recevoir vos données dans un format structuré.</li>
                <li><strong className="text-foreground">Droit de retirer votre consentement</strong> à tout moment.</li>
              </ul>
              <p className="mt-3">
                Pour exercer ces droits, contactez-moi à l'adresse :<br />
                <strong className="text-foreground">contact@jiiastudio.com</strong>
              </p>
              <p className="mt-2">
                Vous disposez également du droit d'introduire une réclamation auprès de la 
                <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline"> CNIL</a> (Commission Nationale de l'Informatique et des Libertés).
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">9. Sécurité</h2>
              <p>
                JIIA Studio met en œuvre les mesures techniques et organisationnelles appropriées pour protéger 
                vos données personnelles contre la perte, l'utilisation abusive, l'accès non autorisé, la divulgation 
                ou la destruction. Les données sont transmises de manière chiffrée via le protocole HTTPS.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground mb-3">10. Modification de la politique</h2>
              <p>
                JIIA Studio se réserve le droit de modifier cette politique de confidentialité à tout moment. 
                La date de dernière mise à jour est indiquée en haut de cette page.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PolitiqueConfidentialite;